/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import {connect} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import {hidePopUp, showPopUp} from '@/actions/modalActions';
import {Get} from '@/api/request';
import * as APPDATA from '@/constants/pcConstAppData';
import {eventBusObject} from '@/observers/eventBus';

const NOT_STABELE_CAPACITANCE_COUNTER = 15;
const CAPACITANCE_STABILITY_THRESHOLD = 0.0006;
const CAPACITANCE_STABILITY_COUNTER_THRESHOLD = 5;

const LOAD_CELL_STABILITY_THRESHOLD = 0.07;
const LOAD_CELL_STABILITY_COUNTER_THRESHOLD = 3;
const NOT_STABELE_LOAD_CELL_COUNTER = 10;

@connect((store) => ({
  isPCRunning: store.setupStore.isPCRunning,
}))
class VolumeSensorStability extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
    this._bus = eventBusObject();
    this._isSensorStabilityCancled = false;
    this._getSensorStability = undefined;
    this._prevSensorValue = undefined;
    // {
    //     "BufferSensor": 36.456142425537109,
    //     "BufferReference": 58.084197998046875,
    //     "ProteinSensor": 37.335010528564453,
    //     "ProteinReference": 57.534736633300781
    // }
    this._sensorCheckCounter = 0;
    this._proteinSensorStableCounter = 0;
    this._bufferSensorStableCounter = 0;
    this.successgetSensorStability = this.successgetSensorStability.bind(this);
  }

  componentDidMount() {
    this.eventSensorStability = this._bus.subscribe(VolumeSensorStabilityEvent.VOLUME_SENSOR_STABILITY, (param) =>
      this.SensorStabilityCheck(param),
    );
  }

  componentWillUnmount() {
    this.eventSensorStability.unsubscribe();
    this.clearGetSensor();
  }

  cancleResetCapacitanceStability = () => {
    this.clearGetSensor();
    this.closeLoading();
    this._isSensorStabilityCancled = true;
  };

  SensorStabilityCheck = () => {
    this._isSensorStabilityCancled = false;
    const propsSensorStabilityCheck = {
      showLoading: true,
      loadingText: APPDATA.MESSAGES.VOLUME_SENSOR_STABILITY_CHECK.CHECK_SYSTEM,
      loadingButton1: {
        label: APPDATA.CANCEL,
        onClick: this.cancleResetCapacitanceStability,
      },
    };
    this.updateMessageLoading(propsSensorStabilityCheck);

    this.getSensor();
  };

  clearGetSensor = () => {
    if (this._getSensorStability === undefined) return;
    clearInterval(this._getSensorStability);
    this._getSensorStability = undefined;
    this._sensorCheckCounter = 0;
    this._proteinSensorStableCounter = 0;
    this._bufferSensorStableCounter = 0;
  };

  onClickNotStablePopUp = (e) => {
    const {id} = e.currentTarget;

    switch (id) {
      case APPDATA.WAIT:
        this.props.dispatch(hidePopUp());
        break;
      case APPDATA.SKIP:
        this.props.dispatch(hidePopUp());
        this.props.callbackVolumeSensorStability();
        break;
      default:
        break;
    }
  };

  capacitanceNotStableAction = () => {
    this.closeLoading();
    const notStableButton = [
      {
        id: APPDATA.WAIT,
        isPrimaryButton: true,
        onClick: this.onClickNotStablePopUp,
        label: APPDATA.WAIT,
      },
      {
        id: APPDATA.SKIP,
        isPrimaryButton: false,
        onClick: this.onClickNotStablePopUp,
        label: APPDATA.SKIP,
      },
    ];
    this.props.dispatch(
      showPopUp({
        popUpTitle: APPDATA.MESSAGES.VOLUME_SENSOR_STABILITY_CHECK.NOT_STABLE.TITLE,
        popUpText: APPDATA.MESSAGES.VOLUME_SENSOR_STABILITY_CHECK.NOT_STABLE.TEXT,

        popUpQuestion: undefined,
        popUpButton: notStableButton,
      }),
    );
    this.clearGetSensor();
  };

  getSensor = () => {
    if (this._getSensorStability) {
      this.clearGetSensor();
    }
    this._getSensorStability = setInterval(() => {
      if (this._isSensorStabilityCancled === true) {
        this.clearGetSensor();
        return;
      }

      const param = {};
      const passingParam = {};
      Get(APPDATA.API.RAW_DATA_VOLUME_SENSOR, param, this.successgetSensorStability, passingParam);
    }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
  };

  successgetSensorStability = (response) => {
    this._sensorCheckCounter += 1;
    const currentRawData = response.data;
    const volumeSensorType =
      currentRawData[APPDATA.KEY.Protein1] === -1
        ? APPDATA.VOLUME_SENSOR_TYPE.LOAD_CELL
        : APPDATA.VOLUME_SENSOR_TYPE.CAPACITANCE;
    if (this._prevSensorValue !== undefined) {
      const currentProteinRefCap =
        volumeSensorType === APPDATA.VOLUME_SENSOR_TYPE.LOAD_CELL
          ? currentRawData[APPDATA.KEY.Protein0]
          : currentRawData[APPDATA.KEY.Protein1];
      const curretnBufferRefCap =
        volumeSensorType === APPDATA.VOLUME_SENSOR_TYPE.LOAD_CELL
          ? currentRawData[APPDATA.KEY.Buffer0]
          : currentRawData[APPDATA.KEY.Buffer1];
      const prevProteinRefCap =
        volumeSensorType === APPDATA.VOLUME_SENSOR_TYPE.LOAD_CELL
          ? this._prevSensorValue[APPDATA.KEY.Protein0]
          : this._prevSensorValue[APPDATA.KEY.Protein1];
      const prevBufferRefCap =
        volumeSensorType === APPDATA.VOLUME_SENSOR_TYPE.LOAD_CELL
          ? this._prevSensorValue[APPDATA.KEY.Buffer0]
          : this._prevSensorValue[APPDATA.KEY.Buffer1];

      const sensorStabilityThreshold =
        volumeSensorType === APPDATA.VOLUME_SENSOR_TYPE.LOAD_CELL
          ? LOAD_CELL_STABILITY_THRESHOLD
          : CAPACITANCE_STABILITY_THRESHOLD;
      const sensorStabilityCounter =
        volumeSensorType === APPDATA.VOLUME_SENSOR_TYPE.LOAD_CELL
          ? LOAD_CELL_STABILITY_COUNTER_THRESHOLD
          : CAPACITANCE_STABILITY_COUNTER_THRESHOLD;
      if (this.sensorDeviation(currentProteinRefCap, prevProteinRefCap) < sensorStabilityThreshold) {
        this._proteinSensorStableCounter += 1;
      }
      if (this.sensorDeviation(curretnBufferRefCap, prevBufferRefCap) < sensorStabilityThreshold) {
        this._bufferSensorStableCounter += 1;
      }
      if (
        this._proteinSensorStableCounter > sensorStabilityCounter &&
        this._bufferSensorStableCounter > sensorStabilityCounter
      ) {
        this.props.callbackVolumeSensorStability();
        this.clearGetSensor();
      }
      const sensorCounterNotStable =
        volumeSensorType === APPDATA.VOLUME_SENSOR_TYPE.LOAD_CELL
          ? NOT_STABELE_LOAD_CELL_COUNTER
          : NOT_STABELE_CAPACITANCE_COUNTER;
      if (this._sensorCheckCounter > sensorCounterNotStable) {
        this.capacitanceNotStableAction();
        // break request
      }
    }
    this._prevSensorValue = currentRawData;
  };

  // eslint-disable-next-line class-methods-use-this
  sensorDeviation = (currentCaps, prevCaps) => Math.abs(currentCaps - prevCaps);

  updateMessageLoading = (props) => {
    this.props.dispatch(
      loadingActions.updateLoading({
        showLoading: props.showLoading,
        loadingText: props.loadingText,
        loadingButton1:
          props.loadingButton1 !== undefined
            ? {
                label: props.loadingButton1.label,
                onClick: props.loadingButton1.onClick,
              }
            : undefined,
      }),
    );
  };

  closeLoading = () => {
    this.updateMessageLoading({
      showLoading: false,
    });
  };

  render() {
    return null;
  }
}

export default VolumeSensorStability;

export const VolumeSensorStabilityEvent = {
  VOLUME_SENSOR_STABILITY: 'VOLUME_SENSOR_STABILITY',
};
